




































import { Component, Prop } from 'vue-property-decorator';
import { IPolicy, IUser, PolicyStatus } from 'admiral-core';
import { ArrowLeftIcon, ArrowRightIcon, PlusIcon, XIcon } from 'vue-feather-icons';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';
import { FormMixin } from '@/mixins/FormMixin';
import FormSubmit from '@/components/common/forms/FormSubmit.vue';
import UserForm from '@/forms/UserForm.vue';
import { UserApi } from '@/services/UserApi';

@Component({
  components: {
    UserForm,
    FormSubmit,
    ArrowLeftIcon,
    ArrowRightIcon,
    PlusIcon,
    XIcon,
  },
})
export default class DeleteUserModal extends mixins(FormMixin, BaseMixin) {
  @Prop({ required: true, type: Object })
  selectedUser!: IUser;

  deleteUserValidationText = '';

  async confirmDeletion() {
    try {
      this.isLoading = true;
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      await UserApi.delete(this.selectedUser.id!, { user: this.selectedUser! });

      this.$emit('deleted');

      this.$toastr.s('Mitarbeiter erfolgreich gelöscht.');
    } catch (e) {
      this.$toastr.e('Beim Löschen des Mitarbeiters ist etwas schief gelaufen.');
      throw e;
    } finally {
      this.isLoading = false;
    }
  }

  async validateDelete() {
    // Reset validation text
    this.deleteUserValidationText = '';

    const response = await UserApi.validateDelete({ user: this.selectedUser! });
    const user = response.data as IUser & {
      tasksCount: number;
      policiesCountCanceled: number;
      policiesCountDeclined: number;
      policiesCountPoliced: number;
      policiesCountSubmitted: number;
      policiesCountOpen: number;
      policiesCountPlanned: number;
    };

    if (user.policiesCountPlanned > 0) {
      this.deleteUserValidationText += `${user.policiesCountPlanned} geplant, `;
    }

    if (user.policiesCountOpen > 0) {
      this.deleteUserValidationText += `${user.policiesCountOpen} offen, `;
    }

    if (user.policiesCountSubmitted > 0) {
      this.deleteUserValidationText += `${user.policiesCountSubmitted} eingereicht, `;
    }

    if (
      user.policiesCountPlanned > 0 ||
      user.policiesCountOpen > 0 ||
      user.policiesCountSubmitted > 0
    ) {
      this.deleteUserValidationText += `(werden dir zugewiesen). `;
    }

    if (user.policiesCountPoliced > 0) {
      this.deleteUserValidationText += `${user.policiesCountPoliced} policiert, `;
    }

    if (user.policiesCountDeclined > 0) {
      this.deleteUserValidationText += `${user.policiesCountDeclined} abgesagt, `;
    }

    if (user.policiesCountPoliced > 0 || user.policiesCountDeclined > 0) {
      this.deleteUserValidationText += `(werden anonymisiert). `;
    }
  }

  cancel() {
    //
  }

  reload() {
    //
  }
}
